var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJbDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "jb",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 51.971,
    height: 52.028,
    viewBox: "0 0 51.971 52.028",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_165",
    "data-name": "Rectangle 165",
    width: 51.971,
    height: 52.028,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_278",
    "data-name": "Group 278",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6687",
    "data-name": "Path 6687",
    d: "M92.047,66.775v9.837c.069,0,.136,0,.2,0a7.2,7.2,0,1,0,0-14.41c-.069,0-.137,0-.2,0Z",
    transform: "translate(-67.413 -45.559)",
    fill: "#307fe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6688",
    "data-name": "Path 6688",
    d: "M47.7,26.231V50.944a10.379,10.379,0,0,0,8.248-10.15V16.081A10.379,10.379,0,0,0,47.7,26.231",
    transform: "translate(-34.931 -11.777)",
    fill: "#ff6505"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6689",
    "data-name": "Path 6689",
    d: "M134.111,1.629c1.828,1.747,2.055,4.459,1.755,6.825-1.629,10.023-9.509,19.706-16.5,26.928-.692.682-1.389,1.359-2.1,2.021l1.333-2.779-2.355.789c.539-.509,1.068-1.028,1.6-1.557,6.656-6.778,14.573-16.323,16.433-25.63.8-4.937-1.428-7.487-6.37-7.074-4.725.418-9.581,2.937-13.2,4.972,4.226-2.948,14.271-9.037,19.409-4.494",
    transform: "translate(-84.005 0)",
    fill: "#020203"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6690",
    "data-name": "Path 6690",
    d: "M33.205,119.933c-.807,1.692-2.729,5.709-3.561,7.44l-1.379-1.562c-.4.327-.8.644-1.211.957-5.275,4.213-21.2,14.334-26.21,6.382-2.759-5.194,1.91-13.269,4.533-17.278.422-.616.671-.988.727-1.064-2.3,4.218-6.278,11.505-4.569,16.835.93,2.716,4.037,3.211,6.69,2.733,6.349-1.216,12.291-5.229,17.552-9.262.367-.286.734-.576,1.1-.875l-1.48-1.675c1.484-.5,6.384-2.147,7.809-2.631",
    transform: "translate(0 -84.083)",
    fill: "#020203"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJbDark);
export default __webpack_public_path__ + "static/media/jb-dark.9dfae81eaa3f3417face551e87f1907c.svg";
export { ForwardRef as ReactComponent };